const Row = ({ children }) => {
    return (
        <>
            {children}
        </>
    );
};

export default Row;